module.exports = __webpack_public_path__ + "img/australia.8e1cc71d.svg";